<template>
    <Row type="form-row" :is-margin-top="false">
        <Column
            :xs-size="trueText.length > 0 ? '4' : '8'"
            :sm-size="columnSize"
            :class="'text-' + leftTextXsAlign + ' text-sm-'+ textAlign"
            v-if="falseText.length > 0"
        >
            <TextTag :is-disabled="modelForm[modelName] !== uncheckedValue"> {{ $t(falseText) }}</TextTag>
        </Column>

        <Column xs-size="4" sm-size="2" :class="'text-'+ textAlign">
            <CheckBox
                :model-form="modelForm"
                :model-name="modelName"
                :checked-value="checkedValue"
                :unchecked-value="uncheckedValue"
                :do-action="doAction"
                :is-disabled="isDisabled"
            />
        </Column>

        <Column
            :md-size="mdSize"
            :xs-size="falseText.length > 0 ? '4' : '8'"
            :sm-size="columnSize"
            :class="'text-' + rightTextXsAlign + ' text-sm-'+ textAlign + ' pt-0.5 font-bold'"
            v-if="trueText.length > 0"
        >
            <TextTag :is-disabled="modelForm[modelName] !== checkedValue">
                {{ $t(trueText) }}
            </TextTag>
        </Column>
    </Row>
</template>

<script>
import Column from "./html/Column";
import CheckBox from "./html/CheckBox";
import Row from "./html/Row";
import TextTag from "./html/TextTag";

export default {
    name: "CheckBoxRow",
    components: {TextTag, Row, CheckBox, Column},
    props: {
        modelForm: {
            type: Object,
            required: true,
        },
        modelName: {
            type: String,
            required: true,
        },

        // optional
        falseText: {
            type: String,
            default: "",
        },
        trueText: {
            type: String,
            default: "",
        },
        doAction: {
            type: Function,
            default: function () {
            },
        },

        // column
        columnSize: {
            type: String,
            default: '2'
        },
        mdSize: {
            type: String,
            default: '2'
        },
        checkedValue: {
            default: true,
        },
        uncheckedValue: {
            default: false,
        },
        textAlign: {
            default: 'center'
        },
        leftTextXsAlign: {
            default: 'left'
        },
        rightTextXsAlign: {
            default: 'right'
        },
        isDisabled: {
            type: Boolean,
            default: false,
        }
    }
}
</script>
